module.exports = {
  externalPayProviderSelector: {
    label: 'Pilih metode transfer elektronik Anda:',
  },
  paymentMethodInfo: {
    achpse: 'Anda akan diarahkan ke situs web bank yang Anda pilih untuk mengotorisasi pendebitan dana. Tersedia untuk rekening tabungan, giro, atau setoran elektronik.',
    bancolombia: 'Tersedia untuk rekening giro dan tabungan. Dengan memilih metode pembayaran ini, Anda akan diarahkan ke situs web Bancolombia.',
  },
  fawryLabel: 'Bayar melalui Fawry',
};
